export default __webpack_public_path__ + "static/macworld_bg-3adc8cff970177f9cb153295bd69b907.png";